module.exports = __webpack_public_path__ + "img/MI.df1b806f.png";